import React, {useState} from "react";

import Loading from "components/Loading";
import PaginationTable from "components/Pagination";

import i18n from "i18next";

import {useQuery} from 'react-query';
import {Buttons} from "components/Buttons";
import {getGoals} from "services/Goals.service";
import {useGoal} from "../../../../contexts/GoalsContext";

export function TableList({
                   selected,
                   label,
                   status = '',
                   trashed = false,
                   param,
                  language
               }) {

    const [data, setData] = useState([]);
    const [paginate, setPaginate] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    const { changeTotalGoals } = useGoal()

    const key = status ? status : trashed && "trashed"

    const filter = selected ? selected?.replace('+', '%2B') : '';

    const {isLoading, isFetching} = useQuery(['goals_list', key, currentPage, filter],
        () => {
            return getGoals(status, currentPage, filter, trashed)
        }, {
            onSuccess: (res) => {
                if (res) {
                    const {data} = res

                    if(!trashed) {
                        changeTotalGoals(status, data.meta.total, language)
                    }

                    setData(data?.data)
                    setPaginate(data?.meta)
                }
            },
            onError: () => {
                //  toast.error(i18n.t('error.badRequest'));
            },
            retry: false,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
        }
    )

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };


    if (isLoading) return <Loading/>

    return (
        <div className="accordion accordion-flush shadow-sm rounded mt-3" id={`accordion-${status}`}>
            <div className="accordion-item rounded">
                <h2 className="accordion-header" id={`heading-${status}`}>
                    <button className={`accordion-button rounded-top ${!selected && "collapsed"} `}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#panel-${status}`} aria-expanded={!!selected}
                            aria-controls="flush-collapseOne">
                         <span className="fs-6 fw-medium">
                            {label}
                        </span>
                    </button>
                </h2>
                <div id={`panel-${status}`} className={`accordion-collapse collapse ${selected && "show"}`}
                     aria-labelledby={`heading-${status}`} data-bs-parent={`#accordion-${status}`}>
                    <div className="accordion-body p-0">
                        <div className="table-responsive">
                            <table
                                className={`table table-hover align-middle mb-0 ${isFetching && "text-muted"}`}>
                                <tbody>

                                {!data.length &&
                                    <tr>
                                        <td>{i18n.t('upload.tableRecords')}</td>
                                    </tr>
                                }

                                {data?.map(item =>
                                    <tr key={item.id}>
                                        <td className="text-wrap text-sm">
                                            <span className="text-muted fw-bolder">{item.codigo}  - </span> { item.titulo_meta }
                                            {/*- {item.id} - {item.status} - {status}*/}
                                        </td>
                                        <td>
                                            <Buttons
                                                trashed={trashed}
                                                id={item.id}
                                                title={item.titulo_meta}
                                                isFetching={isFetching}
                                                param="goals"
                                                status={item.status}
                                            />
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>

                        {data.length > 0 &&
                            <div className="py-3">
                                <PaginationTable
                                    isFetching={isFetching}
                                    paginate={paginate}
                                    handlePageClick={handlePageClick}
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

